/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert, InputGroup, Card,
  NavItem, NavLink, Nav, TabPane, TabContent, CardBody, CardTitle,
} from 'reactstrap';

import classnames from 'classnames';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, FieldArray, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import TagSelector from '../Common/TagSelector';
import BaseGrid from '../Common/BaseGrid';

import AttributesFieldset from './AttributesFieldset';
import IdentifiersFieldset from './IdentifiersFieldset';

function ProfileForm(props) {
  const { actionUrl, entity, t } = props;
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [activeTab, setActiveTab] = useState('1');
  const [addToCartSearch, setAddToCartSearch] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [signal, setSignal] = useState(0);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);
      const result = await post(actionUrl, values);
      setErrorMessage(null);

      toastr.success(`Profile ID ${result.id} saved`, 'Success');
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    title: Yup.string(),
    sku: Yup
      .string()
      .matches(/^sj-/, t('Must begin with "sj-"')),
    condition: Yup.string(),
    brand: Yup
      .string(),
    ship_weight: Yup
      .number()
      .required(t('Required')),
    ship_dims: Yup
      .string()
      .matches(/^[0-9]+x[0-9]+x[0-9]+?$/i, t('Must be in the format LxWxH')),
    description: Yup
      .string().nullable(),
    important: Yup
      .string().nullable(),
    tags: Yup.array().of(
      Yup.object().shape({
        label: Yup.string()
          .required(t('Tag is required'))
          .matches(/^[\w -/]+$/, { message: t('Tags can only contain letters, numbers, dashes, and spaces') }),
        id: Yup.number(),
      }),
    ),
    attributes: Yup.array().of(
      Yup.object().shape({
        label: Yup.string()
          .required(t('Label is required'))
          .matches(/^[\w -]+$/, { message: t('Tags can only contain letters, numbers, dashes, and spaces') }),
        code: Yup.string(),
        pattern: Yup.string(),
        message: Yup.string(),
        required: Yup.boolean(),
      }),
    ),
    channels: Yup.array().of(
      Yup.object().shape({
        channel: Yup.string(),
      }),
    ),
    videos: Yup.array().of(
      Yup.object().shape({
        youtube_id: Yup.string(),
      }),
    ),
    add_to_cart: Yup.array().of(
      Yup.object().shape({
        listing_id: Yup.number(),
      }),
    ),
    identifiers: Yup.array().of(
      Yup.object().shape({
        label: Yup.string()
          .required(t('Label is required'))
          .matches(/^[\w -]+$/, { message: t('Tags can only contain letters, numbers, dashes, and spaces') }),
        code: Yup.string(),
        required: Yup.boolean(),
      }),
    ),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="ListingEditForm" autoComplete="off">
            <Row>
              <Col xxl="7">
                <Card>
                  <CardBody>
                    <CardTitle className="h4">{props.t('Save Profile')}</CardTitle>
                    <Row>
                      <Col md="3">
                        <Nav pills className="flex-column">
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '1',
                              })}
                              onClick={() => {
                                setActiveTab('1');
                              }}
                            >
                              {props.t('General')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '2',
                              })}
                              onClick={() => {
                                setActiveTab('2');
                              }}
                            >
                              {props.t('Attributes')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '3',
                              })}
                              onClick={() => {
                                setActiveTab('3');
                              }}
                            >
                              {props.t('Identifiers')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '4',
                              })}
                              onClick={() => {
                                setActiveTab('4');
                              }}
                            >
                              {props.t('Videos')}
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              style={{ cursor: 'pointer' }}
                              className={classnames({
                                'mb-2': true,
                                active: activeTab === '5',
                              })}
                              onClick={() => {
                                setActiveTab('5');
                              }}
                            >
                              {props.t('Add To Cart')}
                            </NavLink>
                          </NavItem>
                        </Nav>
                      </Col>
                      <Col md="9">
                        <TabContent
                          activeTab={activeTab}
                          className="text-muted mt-4 mt-md-0"
                        >
                          <TabPane tabId="1">
                            <Field name="id" type="hidden" />
                            <div className="row mt-4 mb-4">
                              <Label
                                for="name"
                                className="col-sm-3 col-form-label text-primary"
                              >
                                {props.t('Profile Name')}
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`bg-warning bg-gradient bg-soft form-control ${(errors.name && touched.name ? 'is-invalid' : '')}`}
                                  id="name"
                                  name="name"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="title"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Title')}
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.title && touched.title ? 'is-invalid' : '')}`}
                                  id="title"
                                  name="title"
                                />
                                <ErrorMessage
                                  name="title"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="sku"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Sku')}
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.sku && touched.sku ? 'is-invalid' : '')}`}
                                  id="sku"
                                  name="sku"
                                />
                                <ErrorMessage
                                  name="sku"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="condition"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Condition')}
                                {' '}
                                <span className="text-danger">*</span>
                              </Label>
                              <Col sm={9}>
                                <Field
                                  as="select"
                                  className={`form-control ${(errors.condition && touched.condition ? 'is-invalid' : '')}`}
                                  id="condition"
                                  name="condition"
                                >
                                  <option>{props.t('Select...')}</option>
                                  <option value="New">{props.t('Brand New')}</option>
                                  <option value="Like New">{props.t('Like New')}</option>
                                  <option value="Used">{props.t('Used')}</option>
                                  <option value="Refurbished">{props.t('Refurbished')}</option>
                                  <option value="Other">{props.t('Other')}</option>
                                </Field>
                                <ErrorMessage
                                  name="condition"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="brand"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Brand')}
                              </Label>
                              <Col sm={9}>
                                <Field
                                  type="text"
                                  className={`form-control ${(errors.brand && touched.brand ? 'is-invalid' : '')}`}
                                  id="brand"
                                  name="brand"
                                />
                                <ErrorMessage
                                  name="brand"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="ship_weight"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Ship Weight')}
                              </Label>
                              <Col sm="auto">
                                <div className="input-group">
                                  <Field
                                    type="text"
                                    className={`form-control ${(errors.ship_weight && touched.ship_weight ? 'is-invalid' : '')}`}
                                    id="weight"
                                    name="ship_weight"
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">LBS</span>
                                  </div>
                                </div>

                                {errors
                                  && errors.ship_weight
                                  && touched.ship_weight && (
                                    <div className="text-danger pt-1">{errors.ship_weight}</div>
                                )}
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                for="ship_dims"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Ship Dimensions')}
                              </Label>
                              <Col sm="auto">
                                <div className="input-group">
                                  <Field
                                    type="text"
                                    className={`form-control ${(errors.ship_dims && touched.ship_dims ? 'is-invalid' : '')}`}
                                    id="dimensions"
                                    name="ship_dims"
                                    placeholder="1x1x1"
                                  />
                                  <div className="input-group-append">
                                    <span className="input-group-text">Inches</span>
                                  </div>
                                </div>
                                {errors
                                  && errors.ship_dims
                                  && touched.ship_dims && (
                                    <div className="text-danger pt-1">{errors.ship_dims}</div>
                                )}
                              </Col>
                            </div>

                            <div className="row mt-4 mb-4">
                              <Label
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Tags')}
                              </Label>
                              <Col sm="9">
                                <TagSelector
                                  id="tag_selector"
                                  initialTags={entity.tags}
                                  onUpdate={(tags) => {
                                    setFieldValue('tags', tags);
                                  }}
                                  allowCreate
                                />
                              </Col>
                            </div>

                            <div className="mt-4 mb-4">
                              <Label
                                for="important"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Important Message')}
                              </Label>
                              <Field
                                component="textarea"
                                className={`form-control ${(errors.important && touched.important ? 'is-invalid' : '')}`}
                                id="important"
                                name="important"
                                rows={5}
                              />
                            </div>

                            <div className="mt-4 mb-4">
                              <Label
                                for="description"
                                className="col-sm-3 col-form-label"
                              >
                                {props.t('Marketing Description')}
                              </Label>
                              <Field
                                component="textarea"
                                className={`form-control ${(errors.description && touched.description ? 'is-invalid' : '')}`}
                                id="description"
                                name="description"
                                rows={10}
                              />
                            </div>
                          </TabPane>

                          <TabPane tabId="2">
                            <FieldArray name="attributes" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <label>{props.t('Attributes/USPs')}</label>
                                  <AttributesFieldset
                                    arrayHelpers={arrayHelpers}
                                    suggestedFields={[]}
                                  />
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="3">
                            <FieldArray name="identifiers" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <label>{props.t('Identifiers')}</label>
                                  <IdentifiersFieldset arrayHelpers={arrayHelpers} />
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="4">
                            <FieldArray name="videos" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <Button color="info" size="sm" onClick={() => { arrayHelpers.push({ youtube_id: '' }); }}>{t('Add Video +')}</Button>

                                  {values.videos.map((x, i) => (
                                    <Row key={`video_${i}`} className="mt-4 mb-4">
                                      <Col xxl="6">
                                        <InputGroup className="mt-3 mb-3">
                                          <Field
                                            className="form-control"
                                            name={`videos[${i}].youtube_id`}
                                            placeholder="YouTube video ID"
                                          />
                                          <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                            <span className="mdi mdi-close-thick" />
                                          </Button>
                                        </InputGroup>

                                        <ErrorMessage
                                          name={`videos[${i}].youtube_id`}
                                          component="div"
                                          className="text-danger pt-2"
                                        />

                                        {x.youtube_id !== '' && (
                                          <iframe width="560" height="315" src={`https://www.youtube.com/embed/${x.youtube_id}`} title="YouTube video player" allowFullscreen />
                                        )}
                                      </Col>
                                    </Row>
                                  ))}
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>

                          <TabPane tabId="5">
                            <FieldArray name="add_to_cart" className="mt-3">
                              {(arrayHelpers) => (
                                <div>
                                  <Button color="info" size="sm" onClick={() => { setAddToCartSearch(true); }}>{t('Recommend Additional Listing +')}</Button>

                                  {addToCartSearch === false && (
                                    <BaseGrid
                                      url={url.GET_LISTINGS}
                                      hasSearch={false}
                                      shouldPaginate={false}
                                      shouldUpdate={signal}
                                      list={values.add_to_cart.map((x) => (x.listing_id))}
                                      config={
                                      {
                                        columns: {
                                          thumb: {
                                            label: '',
                                            image: {
                                              src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                              class: 'rounded',
                                              style: { maxHeight: '5rem', maxWidth: '5rem' },
                                            },
                                            translate: false,
                                          },
                                          id: { label: 'ID', sort: true },
                                          sku: { label: 'Sku', sort: true },
                                          title: { label: 'Title', sort: true },
                                          actions: {
                                            label: props.t('Actions'),
                                            actions: [
                                              {
                                                key: 'remove',
                                                icon: 'mdi mdi-close-thick',
                                                class: 'btn btn-sm btn-soft-danger',
                                                alt: props.t('Remove'),
                                                click: (listing) => {
                                                  for (
                                                    let i = 0;
                                                    i < values.add_to_cart.length;
                                                    i += 1
                                                  ) {
                                                    if (
                                                      // eslint-disable-next-line max-len
                                                      listing.id === values.add_to_cart[i].listing_id
                                                    ) {
                                                      arrayHelpers.remove(i);
                                                    }

                                                    setSignal(signal + 1);
                                                  }
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        pagination: {
                                          sort: 'id',
                                          direction: 'desc',
                                          perPage: 30,
                                        },
                                      }
                                      }
                                    />
                                  )}

                                  {addToCartSearch === true && (
                                    <BaseGrid
                                      url={url.GET_LISTINGS}
                                      hasSearch
                                      shouldPaginate={false}
                                      config={
                                      {
                                        columns: {
                                          thumb: {
                                            label: '',
                                            image: {
                                              src: (item) => (`/api/listings/thumbnail/${item.id}`),
                                              class: 'rounded',
                                              style: { maxHeight: '5rem', maxWidth: '5rem' },
                                            },
                                            translate: false,
                                          },
                                          id: { label: 'ID', sort: true },
                                          sku: { label: 'Sku', sort: true },
                                          title: { label: 'Title', sort: true },
                                          actions: {
                                            label: props.t('Actions'),
                                            actions: [
                                              {
                                                key: 'select',
                                                icon: 'mdi mdi-check-bold',
                                                class: 'btn btn-sm btn-soft-dark',
                                                alt: props.t('Select'),
                                                click: (listing) => {
                                                  arrayHelpers.push({
                                                    listing_id: listing.id,
                                                  });

                                                  setAddToCartSearch(false);
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        pagination: {
                                          sort: 'id',
                                          direction: 'desc',
                                          perPage: 30,
                                        },
                                      }
                                      }
                                    />
                                  )}
                                </div>
                              )}
                            </FieldArray>
                          </TabPane>
                        </TabContent>
                      </Col>
                    </Row>

                    <hr />
                    <div className="row justify-content-end">
                      <Col sm={9}>
                        <div className="d-flex flex-row-reverse bd-highlight gap-2">
                          <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                          >
                            {props.t('Submit')}
                          </Button>

                          <Button
                            type="button"
                            color="soft-info"
                            className="w-md text-dark"
                            onClick={() => { history.goBack(); }}
                          >
                            {props.t('Cancel')}
                          </Button>
                        </div>
                      </Col>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col md="5">
                <Card>
                  <CardBody>
                    <CardTitle className="h4">{props.t('Sales Channels')}</CardTitle>

                    <FieldArray name="channels" className="mt-3">
                      {(arrayHelpers) => (
                        <div>
                          <Button color="info" size="sm" onClick={() => { arrayHelpers.push({ channel: '' }); }}>{t('Add Channel +')}</Button>

                          {values.channels.map((x, i) => (
                            <Row key={`channel_${i}`} className="mt-4 mb-4">
                              <Col xxl="6">
                                <InputGroup>
                                  <Field
                                    as="select"
                                    className="form-control"
                                    id={`channel_select_${i}`}
                                    name={`channels[${i}].channel`}
                                  >
                                    <option value="" disabled>{t('Select a Channel')}</option>
                                    <option value="channel_advisor">Channel Advisor</option>
                                    <option value="shopjimmy">ShopJimmy.com</option>
                                    <option value="partner_api">Partner API</option>
                                  </Field>
                                  <Button color="danger" onClick={() => { arrayHelpers.remove(i); }}>
                                    <span className="mdi mdi-close-thick" />
                                  </Button>
                                </InputGroup>

                                <ErrorMessage
                                  name={`channels[${i}].channel`}
                                  component="div"
                                  className="text-danger pt-2"
                                />
                              </Col>
                            </Row>
                          ))}
                        </div>
                      )}
                    </FieldArray>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

ProfileForm.defaultProps = {
  entity: {
    name: '',
    title: '',
    sku: '',
    ship_weight: 1,
    ship_dims: '1x1x1',
    description: '',
    tags: [],
    attributes: [],
    identifiers: [],
    channels: [],
    videos: [],
    add_to_cart: [],
  },
  onSuccess: () => {},
};

ProfileForm.propTypes = {
  actionUrl: PropTypes.string.isRequired,
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.any,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(ProfileForm));
